import React, { useState, useEffect } from "react";
import {
  getApiBaseUrl,
  ADD_ASSET_TYPE,
  ADD_ACTIVITY,
  LOGIN,
} from "../../Config/Config";
import { Spin } from "antd";
import Swal from "sweetalert2";

const NewFilterType = () => {
  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  const [loading, setLoading] = useState(false);
  const [authLoading, setAuthLoading] = useState(false);
  const [askPassword, setAskPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [newAssetType, setNewAssetType] = useState({
    AssetType: "",
    Note: "",
    CreatedBy: user?.UserID || "",
  });

  const logActivity = async (isSuccess, notes) => {
    try {
      await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ActivityType: 1,
          PerformedBy: user?.UserID,
          PerformedOn: new Date().toISOString().slice(0, 19).replace("T", " "),
          Notes: notes,
          Location: "addLocation",
          IsSucces: isSuccess ? 1 : 0,
        }),
      });
    } catch (err) {
      console.error("Failed to log activity:", err);
    }
  };

  const handleAuth = async () => {
    if (!password) {
      setError("Please enter your password.");
      return;
    }

    setAuthLoading(true);
    setError("");

    try {
      if (!user?.UserName) {
        throw new Error("User name not found in session data.");
      }

      const payload = {
        username: user.UserName,
        password,
      };

      const res = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data.status) {
        setAskPassword(false);
        setPassword("");
        await performAdd();
      } else {
        throw new Error(
          data.Message || "Invalid credentials. Please try again."
        );
      }
    } catch (err) {
      setError(err.message || "Unable to authenticate. Please try again.");
    } finally {
      setAuthLoading(false);
    }
  };

  const performAdd = async () => {
    try {
      setLoading(true);

      const response = await fetch(`${getApiBaseUrl()}${ADD_ASSET_TYPE}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(newAssetType),
      });

      const result = await response.json();
      const status = result?.ResultData?.[0];

      if (response.ok && status?.Status === "Success") {
        await logActivity(
          true,
          `Filter Type "${newAssetType.AssetType}" created successfully`
        );
        Swal.fire("Success", "Filter Type added successfully!", "success").then(
          () => {
            window.location.reload();
          }
        );
      } else {
        await logActivity(
          false,
          `Filter Type "${newAssetType.AssetType}" creation failed`
        );
        Swal.fire("Failed", "Something went wrong!", "error");
      }
    } catch (error) {
      console.error("Error adding Filter type:", error);
      await logActivity(
        false,
        `Filter Type "${newAssetType.AssetType}" creation failed`
      );
      Swal.fire("Failed", "Failed to connect to server.", "error");
    } finally {
      setLoading(false);
      setAskPassword(false);
      setPassword("");
      setError("");
    }
  };

  const handleAddAssetTypeSubmit = async (e) => {
    e.preventDefault();

    if (!newAssetType.AssetType) {
      setError("Please fill in the Filter Type field.");
      Swal.fire({
        icon: "warning",
        title: "Validation Error",
        text: "Please fill in the Filter Type field.",
      });
      return;
    }

    if (!user?.UserID) {
      setError("Invalid user data. Please log in again.");
      Swal.fire({
        icon: "error",
        title: "User Data Error",
        text: "Invalid user data. Please log in again.",
      });
      return;
    }

    setAskPassword(true);
  };

  const clearFormData = () => {
    setNewAssetType({
      AssetType: "",
      Note: "",
      CreatedBy: user?.UserID || "",
    });
    setAskPassword(false);
    setPassword("");
    setError("");
  };

  useEffect(() => {
    const offcanvas = document.getElementById("AddAssetTypeOffcanvas");
    if (offcanvas) {
      const handleClose = () => {
        clearFormData();
      };
      offcanvas.addEventListener("hidden.bs.offcanvas", handleClose);
      return () => {
        offcanvas.removeEventListener("hidden.bs.offcanvas", handleClose);
      };
    }
  }, [user]);

  return (
    <>
      {(loading || authLoading) && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div>
        <style>
          {`
        @media (max-width: 576px) {
          #AddAssetTypeOffcanvas {
            width: 90% !important;
          }
        }

        @media (min-width: 577px) and (max-width: 992px) {
          #AddAssetTypeOffcanvas {
            width: 55% !important;
          }
        }

        @media (min-width: 993px) and (max-width: 1440px) {
          #AddAssetTypeOffcanvas {
            width: 25% !important;
          }
        }
          
        @media (min-width: 1441px)  {
          #AddAssetTypeOffcanvas {
            width: 20% !important;
          }
        }
        `}
        </style>
        <div
          className="offcanvas offcanvas-end"
          tabIndex="-1"
          id="AddAssetTypeOffcanvas"
          aria-labelledby="AddAssetTypeOffcanvasLabel"
        >
          <form onSubmit={handleAddAssetTypeSubmit}>
            <div className="offcanvas-header">
              <h5 id="AddAssetTypeOffcanvasLabel">Add Filter Type</h5>
              <div className="d-flex align-items-center ms-auto">
                <button
                  type="submit"
                  className="btn btn-sm btn-outline-success me-2"
                  title="Save"
                >
                  <i className="fa fa-check fs-4"></i>
                </button>
                <button
                  type="button"
                  className="btn-close text-reset"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                ></button>
              </div>
            </div>
            <div className="offcanvas-body">
              {error && (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              )}
              <div className="mb-3">
                <label htmlFor="assetType" className="form-label">
                  Filter Type
                </label>
                <span className="text-danger ms-1">*</span>
                <input
                  type="text"
                  className="form-control"
                  id="assetType"
                  value={newAssetType.AssetType}
                  onChange={(e) =>
                    setNewAssetType({
                      ...newAssetType,
                      AssetType: e.target.value,
                    })
                  }
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="note" className="form-label">
                  Description
                </label>
                <textarea
                  className="form-control"
                  id="note"
                  rows="3"
                  value={newAssetType.Note}
                  onChange={(e) =>
                    setNewAssetType({ ...newAssetType, Note: e.target.value })
                  }
                ></textarea>
              </div>
              {askPassword && (
                <div className="mt-2">
                  <div className="mb-3 w-lg-75 m-auto">
                    <label className="form-label">
                      Confirm Password <span className="text-danger"> *</span>
                    </label>
                    <div className="pass-group">
                      <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        className="pass-input form-control"
                        value={password}
                        onChange={(e) => {
                          setPassword(e.target.value);
                          setError("");
                        }}
                        onCopy={(e) => e.preventDefault()}
                        onPaste={(e) => e.preventDefault()}
                        onCut={(e) => e.preventDefault()}
                        placeholder="Enter Password"
                      />
                      <span
                        className={`ti toggle-password ${
                          showPassword ? "ti-eye" : "ti-eye-off"
                        }`}
                        onClick={() => setShowPassword(!showPassword)}
                      ></span>
                    </div>
                  </div>
                  <button
                    type="button"
                    className="btn btn-primary btn-sm me-2"
                    onClick={handleAuth}
                    disabled={authLoading || !password}
                  >
                    {authLoading ? "Verifying..." : "Confirm"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm"
                    onClick={() => {
                      setAskPassword(false);
                      setPassword("");
                      setError("");
                    }}
                  >
                    Cancel
                  </button>
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default NewFilterType;